import * as React from 'react';
import { RankItem } from '@/fetch.ts';
import defaultAvatar from '@images/default.png';
interface Props extends RankItem {
  width: number,
  revive: boolean,
  chamption: boolean,
}
const Images = Object.keys({
  rankno1: 'rankno1',
  rankno2: 'rankno2',
  rankno3: 'rankno3',
  ranknon: 'ranknon',
  living: 'living',
  revive: 'revive',
}).map((item: any) => require(`./../../assets/images/${item}.png`));
const AnchorItem: React.FC<Props> = props => (
  <div
    style={
      {
        width: props.width + 'px',
        height: (props.revive && props.iRank === 1) ? '82px' : '62px',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        backgroundSize: '332px 82px',
        paddingTop: (props.revive && props.iRank === 1) ? '10px' : '0px',
        background: (props.revive && props.iRank === 1) ? `url(${Images[5].default}) center center no-repeat` : '',
      }
    }
  >
    <i
      style={
        (props.iRank <= 3 && !props.chamption) ? {
          width: '34px',
          height: '28px',
          background: `url(${Images[props.iRank - 1].default}) center center no-repeat`,
          backgroundSize: '100% 100%',
        } : {
          width: '24px',
          height: '24px',
          background: `url(${Images[3].default}) center center no-repeat`,
          backgroundSize: '100% 100%',
          color: 'white',
          textAlign: 'center',
          lineHeight: '24px',
          marginLeft: '5px',
          fontSize: '12px',
        }
      }
    >
      {
        (props.iRank <= 3 && !props.chamption) ? '' : props.iRank
      }
    </i>
    <div
      style={
        {
          width: '170px',
          display: 'flex',
          alignItems: 'center',
          marginLeft: '20px',
        }
      }
    >
      <div
        style={
          {
            position: 'relative',
            width: '42px',
            height: '42px',
            borderRadius: '50%',
            marginRight: '8px',
          }
        }
      >
        <img
          style={
            {
              width: '40px',
              height: '40px',
              borderRadius: '50%',
              border: '1px solid black',
              cursor: 'pointer',
            }
          }
          title={props.sNickName}
          src={props.sLogoUrl}
          onError={(event: any): void => {
            event.target.onerror = null;
            event.target.src = defaultAvatar;
          }}
          onClick={(): void => {
            window.open('https://m.huya.com/' + props.tJump.iRoomId, '_blank');
          }}
        />
        {
          props.tJump.bLive &&
            <i
              style={
                {
                  position: 'absolute',
                  right: '0px',
                  bottom: '0px',
                  width: '13px',
                  height: '13px',
                  background: `url(${Images[4].default}) center center no-repeat`,
                  backgroundSize: '100% 100%',
                }
              }
            ></i>
        }
      </div>
      <p
        style={
          {
            width: '120px',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            margin: '0px',
            fontSize: '14px',
            color: 'white',
            textAlign: 'left',
            cursor: 'pointer',
          }
        }
        onClick={(): void => {
          window.open('https://m.huya.com/' + props.tJump.iRoomId, '_blank');
        }}
      >
        {props.sNickName}
      </p>
    </div>
    <p
      style={
        {
          width: '80px',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          margin: '0px',
          fontSize: '14px',
          color: 'white',
          textAlign: 'right',
        }
      }
    >{props.lScore}</p>
  </div>
)
export default AnchorItem;